import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const RowRenderer = ({ getTableRowId }) => {
  const Renderer = ({
    className,
    columns,
    index,
    key,
    onRowClick,
    onRowDoubleClick,
    onRowMouseOut,
    onRowMouseOver,
    onRowRightClick,
    rowData,
    style,
  }) => {
    const a11yProps = { 'aria-rowindex': index + 1 };

    if (onRowClick
      || onRowDoubleClick
      || onRowMouseOut
      || onRowMouseOver
      || onRowRightClick
    ) {
      a11yProps['aria-label'] = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        a11yProps.onClick = event => onRowClick({ event, index, rowData });
      }
      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = event => onRowDoubleClick({ event, index, rowData });
      }
      if (onRowMouseOut) {
        a11yProps.onMouseOut = event => onRowMouseOut({ event, index, rowData });
      }
      if (onRowMouseOver) {
        a11yProps.onMouseOver = event => onRowMouseOver({ event, index, rowData });
      }
      if (onRowRightClick) {
        a11yProps.onContextMenu = event => onRowRightClick({ event, index, rowData });
      }
    }

    return rowData ? (
      <div
        {...a11yProps}
        className={classnames(className, rowData.className, rowData.checked && 'grb-virtualized-table-row-checked')}
        key={key}
        role="row"
        id={getTableRowId(rowData.obj || rowData)}
        style={style}
      >
        {columns}
      </div>
    ) : (
      <div {...a11yProps} className={className} key={key} role="row" id={`${index}`} style={style}>
        {columns}
      </div>
    );
  };

  Renderer.propTypes = {
    className: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.shape({})),
    index: PropTypes.number,
    key: PropTypes.string,
    onRowClick: PropTypes.func,
    onRowDoubleClick: PropTypes.func,
    onRowMouseOut: PropTypes.func,
    onRowMouseOver: PropTypes.func,
    onRowRightClick: PropTypes.func,
    rowData: PropTypes.shape({
      obj: PropTypes.shape({}),
      className: PropTypes.string,
      checked: PropTypes.bool,
    }).isRequired,
    style: PropTypes.shape({}),
  };

  Renderer.defaultProps = {
    className: undefined,
    columns: undefined,
    index: undefined,
    key: undefined,
    onRowClick: undefined,
    onRowDoubleClick: undefined,
    onRowMouseOut: undefined,
    onRowMouseOver: undefined,
    onRowRightClick: undefined,
    style: undefined,
  };
  return Renderer;
};

export default RowRenderer;
